<template>
  <div class="breadcrumb"> 
    <ul>
      <li v-for="(item, index) in items" :key="index">
        <span :class="[item.status ? 'active' : '']">{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'adx-breadcrumb-progress-status',
  components: {

  },
  props: {
    isActive: {
      type: String,
      required: false
    },
    items:{
      type: Array,
      required: false
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {
    isActive:function(){
      this.reset()
      this.status()
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.status()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    status(){
      let selected = -1
      let progress = this.isActive? this.isActive.toUpperCase():''
      for (var i=0; i<this.items.length;  i++){
        if (this.items[i].title.toUpperCase() === progress) selected = i
      }
      for (var i=selected; i>=0;  i--){
        this.items[i].status = true
      }
    },
    reset(){
      for (var i = 0; i < this.items.length; i++){
        this.items[i].status = false
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>